<template>
  <b-modal
    id="edit-job-code"
    ref="edit-job-code"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('edit_job_code') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <div class="form-container">
        <h5 class="section-title">
          {{ label.get('job_code') }}
        </h5>
        <div class="input-wrapper">
          <input
            v-model="item.name"
            type="text"
            :placeholder="label.get('add_job_code_name_placeholder')"
            class="atto-input"
          >
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          :disabled="disabledSaveButton"
          @click="saveChanges"
        >
          {{ label.get('save_changes') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>

    import JobCodesService from '../services/JobCodesService';
    export default {
        name: "EditJobCodeComponent",
        props: {
            job: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                disabledSaveButton: false,
                item: Object.assign({}, this.job)
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['edit-job-code'].show();
        },
        methods: {

            close() {
                this.$root.$emit('hideEditJobCode');
            },
            saveChanges(){

                if(this.item.name.trim() === '') {
                    return;
                }

                this.disabledSaveButton = true;
                JobCodesService.updateJobCode(this.item.id, this.item).then((response) => {
                    this.job.name = this.item.name;
                    this.$root.$emit('hideEditJobCode', this.job);
                }).catch((error) => {
                    this.disabledSaveButton = false;
                    console.log('Error updating job code.');
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>